import React, { Component, createContext } from "react";
import { Link } from "react-router-dom";

import Tab from "../tableProvider/tab";
import FilterComponent from "../../utils/searchBar";
import BillSummary from "../bill/BillSummary";
import plusImage from "../../../../static/images/plus.svg";

export const tabsContext = createContext({});
const { Provider } = tabsContext;
class Tabs extends Component {
  constructor(props) {
    super(props);
    let activeTab = "";
    if (props.activeTab && props.activeTab !== "") {
      activeTab = props.activeTab;
    } else if (props.children[0] !== undefined) {
      activeTab = props.children[0].props.label;
    } else if (props.children.props) {
      activeTab = props.children.props.label;
    }

    this.state = {
      activeTab: activeTab,
      propTab: props.activeTab,
    };
  }

  componentDidUpdate() {
    const { propTab } = this.state;
    const { activeTab } = this.props;
    if (undefined !== activeTab && activeTab !== "" && propTab !== activeTab) {
      this.setState({ activeTab: activeTab, propTab: activeTab });
    }
  }

  onClickTabItem = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const {
      onClickTabItem,
      props: { headerTitle, billSelection },
      state: { activeTab },
    } = this;

    const children = Array.isArray(this.props.children)
      ? this.props.children
      : [this.props.children];

    return (
      <div className="tabs tabs-admissions">
        <div className="header-tabs ">
          {headerTitle !== null && headerTitle}
          <ol className="tab-list tab-list-user">
            {children.map((child) => {
              const { label, image } = child.props;
              return (
                <Tab
                  activeTab={activeTab}
                  key={label}
                  label={label}
                  image={image}
                  onClick={onClickTabItem}
                />
              );
            })}
          </ol>
          <div className="flex-element left-flex">
            {this.props.buttonLbl && this.props.buttonLnk && (
              <Link to={this.props.buttonLnk} className="add-bill">
                <p className="pBill">{this.props.buttonLbl}</p>
                <img className="plusImage" src={plusImage} />
              </Link>
            )}
            {undefined !== this.props.filterItems &&
              undefined !== this.props.filterSearch && (
                <FilterComponent
                  key={this.state.activeTab}
                  filter={this.props.filterItems}
                  searchFnc={this.props.filterSearch}
                  pageSize={this.props.pageSize}
                  pageSizeItems={this.props.pageSizeItems}
                  handlePageSizeSelection={this.props.handlePageSizeSelection}
                />
              )}
          </div>
        </div>
        {billSelection && this.props.billSelection.totalBillSelection > 0 && (
          <BillSummary billSelection={billSelection} />
        )}

        <div className="tab-content">
          <Provider value={{ onClickTabItem }}>
            {children.map((child) => {
              if (child.props.label !== activeTab) return undefined;
              return child.props.children;
            })}
          </Provider>
        </div>
      </div>
    );
  }
}

export default Tabs;
